import { Component } from '@angular/core';

import { ConfirmDialog } from 'primeng/confirmdialog';

@Component({
  selector: 'app-confirmation-dialog',
  imports: [ConfirmDialog],
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss',
})
export class ConfirmationDialogComponent {}
